import { useState } from "react";
import Modal from "../../modal";
import styles from "./styles.module.css";
import { db } from "../../firebase";
export default function NewApp({ onSubmit, appId }) {
  const [open, setOpen] = useState(false);

  const handleDelete = () => {
    onSubmit();
    setOpen(false);
  };

  return (
    <>
      <button onClick={() => setOpen(true)} className={styles.cardButton}>
        Delete
      </button>
      <Modal open={open} onClose={() => setOpen(false)}>
        <div className={styles.newApp}>
          <div className={styles.cardTitle}>Delete {appId}</div>
          <div className={styles.inputText}>
            This can't be undone and all your app and databse data will be lost.
          </div>
          <button onClick={handleDelete} className={styles.newAppButton}>
            Delete
          </button>
        </div>
      </Modal>
    </>
  );
}
